import React, { useEffect, useState, memo, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import Favicon from 'react-favicon';

import * as faviconNotifications from 'statics/images/favicon/unread';
import favIconOffline from 'statics/images/favicon/offline.png';
import useWhyDidYouUpdate from 'hooks/useWhyDidYouUpdate';
import { ThemeContext } from 'styled-components';
import { useEvent } from 'react-use';

const getNotificationFavicon = count =>
    (count <= 5 ? faviconNotifications[`unread${count}`] : faviconNotifications.unread5plus);

const MyFavicon = (props) => {
    const { feedNotificationCounter = 0, isOnline, isWsOpen } = props;
    const skin = useContext(ThemeContext);
    const { favicon } = skin || {};
    const [url, setUrl] = useState(favicon);
    const [isBrowserReady, setIsBrowserReady] = useState(false);

    const handleClick = useCallback(() => {
        setIsBrowserReady(true);
    }, []);
    
    useEvent('click', handleClick);

    useWhyDidYouUpdate('favicon', { ...props, skin });

    useEffect(() => {
        if (!isOnline || !isWsOpen || !isBrowserReady) {
            setUrl(favIconOffline);
        } else if (feedNotificationCounter > 0) {
            setUrl(getNotificationFavicon(feedNotificationCounter));
        } else {
            setUrl(favicon);
        }
    }, [feedNotificationCounter, favicon, isOnline, isWsOpen, isBrowserReady])

    return <Favicon url={url} />;
}

MyFavicon.propTypes = {
    feedNotificationCounter: PropTypes.number,
    isOnline: PropTypes.bool.isRequired,
    isWsOpen: PropTypes.bool.isRequired
};

export default memo(MyFavicon);
